import { useSession } from '../Context';
import { useEffect, useState } from 'react';

const EditableName = () => {
  const {
    document: { user },
  } = useSession();
  const [successClass, setSuccessClass] = useState('bg-none');
  const [name, setName] = useState(user.name);
  useEffect(() => {
    const timer = setTimeout(() => {
      user.name = name;
      user
        .save()
        .then((success) =>
          setSuccessClass(success ? 'bg-success' : 'bg-error'),
        );
    }, 500);
    setName(name);
    return () => clearTimeout(timer);
  }, [user, name]);

  useEffect(() => {
    if (successClass === 'bg-success') {
      const timer = setTimeout(() => {
        setSuccessClass('bg-none');
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [successClass]);
  return (
    <label className='input'>
      Nom
      <input
        type='text'
        className={`grow ${successClass}`}
        placeholder='Nom'
        value={name}
        onChange={({ target }) => setName(target.value)}
      />
    </label>
  );
};

export default EditableName;
